export const style = {
  blockBookingForContainer: {
    marginTop: { xs: "0rem", lg: "2rem" },
    width: "100%",
  },
  autocompleteContainer: {
    "& .MuiOutlinedInput-root": {
      paddingRight: "1.5rem!important",
    },
  },
  selectBlockBookingForContainer: {
    position: "absolute",
    right: "2%",
    margin: 0,
    paddingRight: 0,
    cursor: "pointer",
  },
  blockBookingForChipCloseIcon: {
    color: "var(--gray-1000)",
    fontSize: "1.4rem",
  },
  selectBlockBookingFor: {
    color: "var(--orange-500)",
    fontSize: "1.4rem",
    fontWeight: 500,
    padding: 0,
    cursor: "pointer",
  },
  blockBookingForChip: {
    backgroundColor: "var(--gray-20)",
  },
};
